import $ from 'jquery';
/* global x5script */

class Ebook {
  constructor() {
    this.ebookData = x5script.ebook;

    $(document).on('pumBeforeOpen', e => {
      this.popup = $(e.target);
      this.content = this.popup.find('.popmake-content');
      this.removePTags();
    });

    $(document).on('gform_confirmation_loaded', (event, formId) => {
      this.content = $(`.gform_confirmation_message_${formId}`);
      this.removePTags();

      if (this.ebookData.file_url !== '') {
        setTimeout(() => {
          // eslint-disable-next-line no-unused-expressions
          window.open(this.ebookData.file_url, '_blank') ||
            window.location.replace(this.ebookData.file_url);
        }, 3000);
      }
    });
  }

  removePTags() {
    const paragraphs = this.content.find('p');

    if (paragraphs.length) {
      paragraphs.each((i, p) => {
        if (
          $(p)
            .html()
            .replace(/\s|&nbsp;/g, '').length === 0
        ) {
          $(p).remove();
        }
      });
    }
  }
}

export default new Ebook();



// WEBPACK FOOTER //
// ./src/scripts/modules/ebook.js